module.exports = __webpack_public_path__ + "img/89_25.813cd501.png";